import { render, staticRenderFns } from "./BannerCookie.vue?vue&type=template&id=30b2af40&scoped=true"
import script from "./BannerCookie.vue?vue&type=script&lang=js"
export * from "./BannerCookie.vue?vue&type=script&lang=js"
import style0 from "./BannerCookie.vue?vue&type=style&index=0&id=30b2af40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2af40",
  null
  
)

export default component.exports